module.exports = __webpack_public_path__ + "1689d1dc7fdcda7e7160b9f811df50fd.pdf";